<template lang="pug">
div
  h4 {{ `${titulo}` }}
  trumbowyg(v-model="text" @tbw-blur="emitTextChange" :config="config" :placeholder="placeholder")

</template>

<script>

export default {
  props: {
    titulo: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Digite o texto...'
    }
  },

  watch: {
    value: function (val) {
      this.text = val
    }
  },

  data () {
    return {
      body: '',
      config: {
        lang: 'pt_br',
        tagsToRemove: ['script', 'link'],
        removeformatPasted: true,
        btns: [
          ['strong', 'italic', 'underline', 'strikethrough'],
          ['removeformat'],
          ['formatting'],
          ['unorderedList', 'orderedList'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['undo', 'redo']
        ],
        semantic: {
          'br': '/br'
        }
      },
      text: ''
    }
  },

  created () {
    this.text = this.value
  },

  methods: {
    emitTextChange () {
      this.$emit('onTextChange', this.text)
    }
  }
}
</script>
<style lang="scss">
  .trumbowyg-button-pane {
    background: white;
  }

  .trumbowyg-pt_br {
    margin: 0;
    margin-top: -20px;
  }

  .trumbowyg {
    border-radius: 4px;
  }

  .trumbowyg-button-pane {
    z-index: 7; // Abaixa o z-index  de 11 para 8
  }

  .trumbowyg-button-pane {
    button:hover, button:focus, button.trumbowyg-active {
      svg {
        fill: #279d63;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AppEditorTextoModal.vue